import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import { UIOption } from './ui-option';
import { html } from '../../global/template-literals';
import type { UIFlagGlyph } from '../icon/ui-icon.types';
import styles from './ui-option-dial.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIOption}
 * @alias UIOptionDial
 * @element ui-option-dial
 * @classdesc Represents a class for <code>ui-option-dial</code> element.
 * Similar to ui-option, but holds telephone numbers. Used with
 * <code>ui-dropdown layout="dial"</code> and <code>ui-option-list</code>.
 * @property {UIFlagGlyph} [flag] {@attr flag} Flag of the country.
 * @property {string} [value] {@attr value} Value of the dial option.
 * @example
 * <ui-dropdown layout="dial">
 *   <select>
 *     <option data-flag="ee" value="+372">Estonia</option>
 *     <option data-flag="lv" value="+371">Latvia</option>
 *   </select>
 * </ui-dropdown>
 * @example
 * <ui-option-list label="Select dial code">
 *   <ui-option-dial optgroup text="Baltic"></ui-option-dial>
 *   <ui-option-dial flag="ee" value="+372" text="Estonia"></ui-option-dial>
 *   <ui-option-dial flag="lv" value="+371" text="Latvia" selected></ui-option-dial>
 * </ui-option-list>
 */
@Component({
    tag: 'ui-option-dial',
    styles,
})
export class UIOptionDial extends UIOption {
    static readonly HandlesOwnControl = true;

    @Attribute(String) flag?: UIFlagGlyph;

    /**
     * @inheritDoc
     */
    render(): void {
        this.updateClassList({
            'ui-option-dial': true,
        });

        const flagStyleClass = `-flag ${this.flag ? this.flag : ''}`;

        this.insertElements(
            this.optgroup
                ? [this.buildOptGroupLabel()]
                : [
                      html`
                          <div class="${flagStyleClass}"></div>
                          <span class="dial-code">${this.value}</span>
                          <span class="dial-name">${this.text}</span>
                          ${this.control &&
                          html`<ui-icon glyph="redesign-caret-down"></ui-icon>`}
                      `,
                  ]
        );

        super.render();
    }
}
